import React from "react";
import {
  StyleProp,
  StyleSheet,
  Text,
  TextStyle,
  View,
  ViewStyle,
} from "react-native";

import { ADMIN_TOKENS } from "../../../styles/adminTokens";

type ToastMessageTone = "success" | "error" | "neutral";

type ToastMessageProps = {
  message: string;
  tone?: ToastMessageTone;
  style?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
};

const ToastMessage: React.FC<ToastMessageProps> = ({
  message,
  tone = "neutral",
  style,
  textStyle,
}) => {
  return (
    <View
      accessibilityRole="alert"
      accessibilityLiveRegion="polite"
      style={[
        styles.toast,
        tone === "success" ? styles.toastSuccess : null,
        tone === "error" ? styles.toastError : null,
        style,
      ]}
      pointerEvents="none"
    >
      <Text
        style={[
          styles.toastText,
          tone === "success" ? styles.toastTextSuccess : null,
          tone === "error" ? styles.toastTextError : null,
          textStyle,
        ]}
      >
        {message}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  toast: {
    borderRadius: ADMIN_TOKENS.radius.md,
    borderWidth: ADMIN_TOKENS.borderWidth.sm,
    borderColor: ADMIN_TOKENS.color.borderInput,
    backgroundColor: ADMIN_TOKENS.color.surface,
    paddingVertical: ADMIN_TOKENS.spacing.sm,
    paddingHorizontal: ADMIN_TOKENS.spacing.lg,
  },
  toastSuccess: {
    borderColor: ADMIN_TOKENS.color.borderAccent,
    backgroundColor: ADMIN_TOKENS.color.surfaceAccent,
  },
  toastError: {
    borderColor: ADMIN_TOKENS.color.errorBorder,
    backgroundColor: ADMIN_TOKENS.color.errorSurface,
  },
  toastText: {
    color: ADMIN_TOKENS.color.textPrimary,
    fontFamily: ADMIN_TOKENS.font.medium,
    fontSize: ADMIN_TOKENS.fontSize.sm,
    lineHeight: ADMIN_TOKENS.lineHeight.sm,
  },
  toastTextSuccess: {
    color: ADMIN_TOKENS.color.accentDark,
  },
  toastTextError: {
    color: ADMIN_TOKENS.color.errorTextStrong,
  },
});

export default ToastMessage;
